import { ENTITY_STATUS, CRON_RUN_STATUS, SOURCE } from 'constants/status';

export const MOCK_CRON_JOBS = [
  {
    id: 'cron-1',
    job_name: 'Divya Bhaskar — Ahmedabad (Telegram)',
    newspaper_id: 'np-1',
    newspaper_name: 'Divya Bhaskar',
    edition: 'Ahmedabad',
    source: SOURCE.TELEGRAM,
    source_details: 't.me/divyabhaskar_amd',
    frequency: 'daily',
    time: '07:00',
    timezone: 'Asia/Kolkata',
    day_of_week: null,
    day_of_month: null,
    cron_expression: '0 7 * * *',
    last_run_at: '2026-06-29T07:00:00Z',
    last_run_status: CRON_RUN_STATUS.SUCCESS,
    last_error: null,
    next_run_at: '2026-06-30T07:00:00Z',
    status: ENTITY_STATUS.ACTIVE,
    created_at: '2026-02-01T06:00:00Z',
    updated_at: '2026-06-29T07:00:00Z',
  },
  {
    id: 'cron-2',
    job_name: 'Gujarat Samachar — Vadodara (E-Paper)',
    newspaper_id: 'np-2',
    newspaper_name: 'Gujarat Samachar',
    edition: 'Vadodara',
    source: SOURCE.EPAPER_PDF,
    source_details: 'https://epaper.gujaratsamachar.com/vadodara',
    frequency: 'daily',
    time: '08:00',
    timezone: 'Asia/Kolkata',
    day_of_week: null,
    day_of_month: null,
    cron_expression: '0 8 * * *',
    last_run_at: '2026-06-29T08:00:00Z',
    last_run_status: CRON_RUN_STATUS.FAILED,
    last_error: 'PDF download timed out',
    next_run_at: '2026-06-30T08:00:00Z',
    status: ENTITY_STATUS.ACTIVE,
    created_at: '2026-02-03T06:00:00Z',
    updated_at: '2026-06-29T08:05:00Z',
  },
  {
    id: 'cron-3',
    job_name: 'Sandesh — Junagadh (Chat)',
    newspaper_id: 'np-3',
    newspaper_name: 'Sandesh',
    edition: 'Junagadh',
    source: SOURCE.EPAPER_CHAT,
    source_details: 'sandesh-junagadh-group',
    frequency: 'weekly',
    time: '06:30',
    timezone: 'Asia/Kolkata',
    day_of_week: 'Monday',
    day_of_month: null,
    cron_expression: '30 6 * * 1',
    last_run_at: '2026-06-29T06:30:00Z',
    last_run_status: CRON_RUN_STATUS.SUCCESS,
    last_error: null,
    next_run_at: '2026-06-30T06:30:00Z',
    status: ENTITY_STATUS.ACTIVE,
    created_at: '2026-02-05T06:00:00Z',
    updated_at: '2026-06-29T06:30:00Z',
  },
  {
    id: 'cron-4',
    job_name: 'Dainik Jagran — Lucknow (Telegram)',
    newspaper_id: 'np-4',
    newspaper_name: 'Dainik Jagran',
    edition: 'Lucknow',
    source: SOURCE.TELEGRAM,
    source_details: 't.me/jagran_lko',
    frequency: 'monthly',
    time: '07:00',
    timezone: 'Asia/Kolkata',
    day_of_week: null,
    day_of_month: 1,
    cron_expression: '0 7 1 * *',
    last_run_at: '2026-06-28T07:00:00Z',
    last_run_status: CRON_RUN_STATUS.IDLE,
    last_error: null,
    next_run_at: null,
    status: ENTITY_STATUS.INACTIVE,
    created_at: '2026-02-10T06:00:00Z',
    updated_at: '2026-06-20T06:00:00Z',
  },
];

export default MOCK_CRON_JOBS;
